export default __webpack_public_path__ + "static/103-b769e59cce59b4ec7d6a80d77e60d9f8.jpg";